import type { Definition } from '@exodus/dependency-types';

const isRestoringDefinition = {
  id: 'application.selectors.isRestoring',
  factory: () => (state) => state.app?.isRestoring ?? false,
} as const satisfies Definition;

export default isRestoringDefinition;
